import React, { useRef } from "react";
import { Outlet } from "react-router-dom";
import { useTheme, useMediaQuery } from "@mui/material";
import UtilitySubMetering from "./UtilitySubMetering";
import UtilitySubMeteringMobile from "./UtilitySubMeteringMobile";

const UtilitySubMeteringWrapper = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  // Create dummy refs to provide a valid Outlet context.
  const contentRef = useRef(null);
  const sentinelRef = useRef(null);

  return (
    <div>
      {isMobile ? <UtilitySubMeteringMobile /> : <UtilitySubMetering />}
      {/* This Outlet will render nested routes if any, and provides the expected context */}
      <Outlet context={{ contentRef, sentinelRef }} />
    </div>
  );
};

export default UtilitySubMeteringWrapper;
